<template>
    <fb-form-body>
        <el-form :model="formData" :rules="rules" ref="form" label-width="100px" class="fb-form">

            <el-form-item label="类别名称" prop="name" :error="formErrorMsg.name">
                <el-input v-model="formData.name"></el-input>
            </el-form-item>

            <el-form-item label="类别标识" prop="flag" :error="formErrorMsg.flag">
                <el-input v-model="formData.flag" ></el-input>
            </el-form-item>

            <el-form-item label="大小限制" prop="sizeLimit">
                <el-input v-model="formData.sizeLimit" ></el-input>
            </el-form-item>

            <el-form-item label="类型限制" prop="typeLimit">
                <el-input v-model="formData.typeLimit" ></el-input>
            </el-form-item>


            <el-form-item label="类别状态" prop="status">
                <el-select v-model="formData.status" placeholder="选择文件类别状态">
                    <el-option label="正常" value="1"></el-option>
                    <el-option label="禁用" value="0"></el-option>
                </el-select>
            </el-form-item>



            <el-form-item>
                <el-button type="primary" @click="handleSubmit('form')">确定</el-button>
                <el-button @click="handleReset('form')">重置</el-button>
            </el-form-item>
        </el-form>
    </fb-form-body>
</template>

<script>
    export default {
        name: "RuleEdit",
        components: {},
        data() {
            return {
                api:{
                   update:this.$api.fileCategory.update,
                   detail:this.$api.fileCategory.detail,
                },
                formErrorMsg:{ name: '',
                    flag: '',
                    sizeLimit: '',
                    typeLimit: '',
                    status: '',},
                formData: {
                    code: '',
                    name: '',
                    flag: '',
                    sizeLimit: '',
                    typeLimit: '',
                    status: '',
                },
                rules: {
                    name: [
                        {required: true, message: '请输入文件类别名称', trigger: 'blur'},
                    ],
                    flag: [
                        {required: true, message: '请输入文件类别标识', trigger: 'blur'},
                    ],
                    status: [
                        {required: true, message: '请选择文件类别状态', trigger: 'blur'},
                    ]

                }
            }
        },
        methods: {
            handleSubmit(form) {

                let vm = this;
                vm.$refs[form].validate((valid) => {
                    if (valid) {
                        vm.$http.post(vm.api.update,vm.$qs.stringify(this.formData)).then((resp)=>{

                            if(resp.data.status === 200){
                                vm.$message({
                                    type:'success',
                                    message: resp.data.desc
                                });
                                vm.$router.cgBack();
                            }else if(resp.data.status === 400){
                                resp.data.data.errorFields.forEach(function (a) {

                                    vm.formErrorMsg[a.name] = '';
                                    vm.$nextTick(() => {
                                        vm.formErrorMsg[a.name] = a.message;
                                    });


                                });
                                vm.$message({
                                    type:"error",
                                    message: resp.data.desc
                                });
                            }else{
                                vm.$message({
                                    type:"error",
                                    message: resp.data.desc
                                })
                            }

                        });
                        return true;
                    } else {
                        return false;
                    }
                });

            },
            handleReset(form) {
                this.$refs[form].resetFields();
            }
        },

        created() {

            let vm = this;
            this.$http.post(this.api.detail,this.$qs.stringify(this.$route.query)).then(function (resp) {
                for(let key in resp.data.data){
                    for(let fKey in vm.formData){
                        vm.formData[fKey] = resp.data.data[key][fKey]

                        if(fKey === 'birthday' && vm.formData[fKey]){
                            vm.formData['birthday'] = vm.$moment(vm.formData[fKey]).format('YYYY-MM-DD');
                        }

                    }
                }
            });

        }
    }
</script>

<style lang="scss" scoped>

    .fb-form {
        max-width: 500px;
    }

</style>